import { render, staticRenderFns } from "./ReturnEnvelopeModal.vue?vue&type=template&id=0ca89342&scoped=true&"
import script from "./ReturnEnvelopeModal.vue?vue&type=script&lang=ts&"
export * from "./ReturnEnvelopeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca89342",
  null
  
)

export default component.exports